var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "home text-center text-md-left" },
    [
      _c("Header"),
      _vm._v(" "),
      _c("CreatedCBOs"),
      _vm._v(" "),
      _c("StatisticsBar"),
      _vm._v(" "),
      _c("WholisticApproach"),
      _vm._v(" "),
      _c("Testimonials"),
      _vm._v(" "),
      _c("AboutWellconnected"),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }